/**
 * One render of what a screen says at its top: whether to bring it into view,
 * and what now counts as read. What the bar showed counts as read once nothing
 * was on its way: a sentence the merchant's own edit moves back up stays put,
 * and one whose call's read-back takes the bar away comes into view.
 */
export function saidStep(
  seen: string | null,
  said: string | null,
  atTop: boolean,
  busy: boolean,
): { scroll: boolean; seen: string | null } {
  return {
    scroll: atTop && said !== null && said !== seen,
    seen: atTop || !busy || said === null ? said : seen,
  };
}
